import apiClient from './apiClient';

const baseUrl = process.env.REACT_APP_BASE_URL;

class PaymentService {
  // Get all subscription plans
  async getPlans() {
    try {
      const response = await apiClient.get(`${baseUrl}/payment/plans`);
      return response.data;
    } catch (error) {
      console.error('Error fetching plans:', error);
      throw error;
    }
  }

  // Get specific plan by ID
  async getPlanById(planId) {
    try {
      const response = await apiClient.get(`${baseUrl}/payment/plans/${planId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching plan:', error);
      throw error;
    }
  }

  // Create payment order
  async createOrder(orderData) {
    try {
      const response = await apiClient.post(`${baseUrl}/payment/create-order`, orderData);
      return response.data;
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  }

  // Verify payment
  async verifyPayment(paymentData) {
    try {
      const response = await apiClient.post(`${baseUrl}/payment/verify-payment`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error verifying payment:', error);
      throw error;
    }
  }

  // Get payment details
  async getPaymentDetails(orderId) {
    try {
      const response = await apiClient.get(`${baseUrl}/payment/details/${orderId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching payment details:', error);
      throw error;
    }
  }

  // Health check
  async healthCheck() {
    try {
      const response = await apiClient.get(`${baseUrl}/payment/health`);
      return response.data;
    } catch (error) {
      console.error('Error checking payment service health:', error);
      throw error;
    }
  }
}

export default new PaymentService();
